import { createActionCreator } from 'deox';
import { ApiDoc, Paging } from '@/types';
import { ApiDocForm } from '@/services/api-portal';

export const searchApiDocsActions = {
  request: createActionCreator('SEARCH_API_DOCS_REQUEST', (resolve) => (apiName: string) =>
    resolve({ apiName }),
  ),
  success: createActionCreator(
    'SEARCH_API_DOCS_SUCCESS',
    (resolve) => (groups: string[], apiDocs: ApiDoc[], totalRecords: number) =>
      resolve({ groups, apiDocs, totalRecords }),
  ),
  failure: createActionCreator('SEARCH_API_DOCS_FAILURE', (resolve) => (error: unknown) =>
    resolve({ error }),
  ),
};

export const fetchApiDocActions = {
  request: createActionCreator(
    'FETCH_API_DOC_REQUEST',
    (resolve) => (id: string, organisationId: string) => resolve({ id, organisationId }),
  ),
  success: createActionCreator('FETCH_API_DOC_SUCCESS', (resolve) => (api: ApiDoc) =>
    resolve({ api }),
  ),
  failure: createActionCreator('FETCH_API_DOC_FAILURE', (resolve) => (error: unknown) =>
    resolve({ error }),
  ),
};

export const apiDocActions = {
  clearSwagger: createActionCreator('API_DOC_CLEAR_SWAGGER', (resolve) => (apiId: string) =>
    resolve({ apiId }),
  ),
};

export const fetchApiDocsActions = {
  request: createActionCreator(
    'FETCH_API_DOCS_REQUEST',
    (resolve) => (
      organisationId: string,
      pageNumber?: number,
      pageSize?: number,
      searchText?: string,
      groupName?: string,
    ) => {
      return resolve({ organisationId, pageNumber, pageSize, searchText, groupName });
    },
  ),
  success: createActionCreator(
    'FETCH_API_DOCS_SUCCESS',
    (resolve) => (data: ApiDoc[], paging: Paging) => {
      return resolve({ data, paging });
    },
  ),
  failure: createActionCreator('FETCH_API_DOCS_FAILURE', (resolve) => (error: unknown) =>
    resolve({ error }),
  ),
};

export const fetchApiGroupsActions = {
  request: createActionCreator(
    'FETCH_API_GROUPS_REQUEST',
    (resolve) => (organisationId: string) => {
      return resolve({ organisationId });
    },
  ),
  success: createActionCreator('FETCH_API_GROUPS_SUCCESS', (resolve) => (data: string[]) => {
    return resolve({ data });
  }),
  failure: createActionCreator('FETCH_API_GROUPS_FAILURE', (resolve) => (error: unknown) =>
    resolve({ error }),
  ),
};

export const voteApiDocActions = {
  request: createActionCreator('VOTE_API_DOC_REQUEST', (resolve) => (id: string) =>
    resolve({ id }),
  ),
  success: createActionCreator('VOTE_API_DOC_SUCCESS', (resolve) => (id: string) =>
    resolve({ id }),
  ),
  failure: createActionCreator('VOTE_API_DOC_FAILURE', (resolve) => (error: unknown) =>
    resolve({ error }),
  ),
};

export const rateApiDocActions = {
  request: createActionCreator('RATE_API_DOC_REQUEST', (resolve) => (id: string, rating: number) =>
    resolve({ id, rating }),
  ),
  success: createActionCreator('RATE_API_DOC_SUCCESS'),
  failure: createActionCreator('RATE_API_DOC_FAILURE', (resolve) => (error: unknown) =>
    resolve({ error }),
  ),
};

export const createApiDocActions = {
  request: createActionCreator('CREATE_API_DOC_REQUEST', (resolve) => (apiDoc: ApiDocForm) =>
    resolve({ apiDoc }),
  ),
  success: createActionCreator('CREATE_API_DOC_SUCCESS'),
  failure: createActionCreator('CREATE_API_DOC_FAILURE', (resolve) => (error: unknown) =>
    resolve({ error }),
  ),
};

export const editApiDocActions = {
  request: createActionCreator(
    'EDIT_API_DOC_REQUEST',
    (resolve) => (id: string, apiDoc: ApiDocForm) => resolve({ id, apiDoc }),
  ),
  success: createActionCreator('EDIT_API_DOC_SUCCESS'),
  failure: createActionCreator('EDIT_API_DOC_FAILURE', (resolve) => (error: unknown) =>
    resolve({ error }),
  ),
};

export const deleteApiDocActions = {
  request: createActionCreator('DELETE_API_DOC_REQUEST', (resolve) => (id: string) =>
    resolve({ id }),
  ),
  success: createActionCreator('DELETE_API_DOC_SUCCESS'),
  failure: createActionCreator('DELETE_API_DOC_FAILURE', (resolve) => (error: unknown) =>
    resolve({ error }),
  ),
};

export const downloadApiSwaggerActions = {
  request: createActionCreator(
    'DOWNLOAD_API_SWAGGER_REQUEST',
    (resolve) => (apiId: string, organisationId: string) => resolve({ apiId, organisationId }),
  ),
  success: createActionCreator('DOWNLOAD_API_SWAGGER_SUCCESS'),
  failure: createActionCreator('DOWNLOAD_API_SWAGGER_FAILURE', (resolve) => (error: unknown) =>
    resolve({ error }),
  ),
};
